import React, { Component } from "react";
import { 
    Alert,
    Button,
    Col,
    Container,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    FormGroup
} from "reactstrap";
import Datetime from "react-datetime";
// styles
import './MaskAsCompleted.css'

class MaskAsCompleted extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            clientAction: {},
            documentFile: null,
            approved_date: null
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        const { selectedClientAction } = this.props;
    
        this.setState((prevState) => ({
          modal: !prevState.modal,
          clientAction: {
              ...selectedClientAction,
              entries: [
                {
                    response: '',
                }
            ]
            }
        }));
    }

    setResponse = (response) => {
        this.setState(() => ({
            response: response
        }));
    }

    onChangeApprovedDate = (date) => {
        this.setState(() => ({
            approved_date: date
        }));
    }

    render() {

        const { 
            backdrop = false,
            onSave,
            loading,
            error,
        } = this.props;

        const { 
            documentFile,
            clientAction,
            response = '',
            approved_date
        } = this.state;

        const {
            request,
            justification,
            owner = {},
            client = {},
        } = clientAction || {};


        return(
            <Modal backdrop={backdrop} isOpen={this.state.modal} toggle={this.toggle}>
                <ModalHeader toggle={this.toggle}>Mark Selected Client Action as Completed</ModalHeader>
                <ModalBody className="mark-completed-modal">
                    <Container>
                            <small className="mb-0">Processed by</small>
                            <p className="mb-0">{owner.first_name} {owner.last_name}</p>

                            <small className="mb-0">Client</small>
                            <p className="mb-0">{client.first_name} {client.last_name}</p>

                            <small className="mb-0">Request</small>
                            <p className="mb-0">{request}</p>

                            <small className="mb-0">Details</small>
                            <p>{justification}</p>

                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Approved Date <span className="required-start">*</span></Label>
                                        <Datetime
                                            inputProps={{
                                                className: "form-control",
                                                placeholder: "Approved Date",
                                                name: "approvedDate"
                                            }}
                                            dateFormat="MM/DD/YYYY"
                                            timeFormat={false}
                                            value={approved_date}
                                            onChange={this.onChangeApprovedDate}
                                            closeOnSelect={true}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Response <span className="required-start">*</span></Label>
                                        <Input
                                            type="text"
                                            name="response"
                                            placeholder="response"
                                            value={response}
                                            onChange={(e) => this.setResponse(e.target.value)} 

                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className='d-block'>File <span className="required-start">*</span></Label>
                                        <input
                                            ref={(c) => this.fileUploadRef = c}
                                            type="file"
                                            name="documentFile"
                                            onChange={(e) => this.setState({ documentFile: e.target.files[0] })}
                                            style={{display: 'none'}}
                                        />
                                        <Button
                                            className="btn-round"
                                            color="info"
                                            onClick={() => this.fileUploadRef.click()}
                                            style={{fontSize: '14px'}}
                                        >	
                                            Upload{" "}
                                            <i className="tim-icons icon-upload" />
                                        </Button>
                                        <span>{documentFile?.name}</span>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {error && 
                                <Alert color="danger">
                                    {error.message}
                                </Alert>
                            }
                            <ModalFooter className="justify-content-end">
                                <Button 
                                    color="primary" 
                                    className="btn-success-override mr-2" 
                                    onClick={() => onSave(response, documentFile, approved_date)}
                                    disabled={loading}
                                    
                                >
                                    {loading ? "Saving" : "Save"}
                                </Button>
                                <Button color="secondary" className="btn-danger-override" onClick={this.toggle}>Cancel</Button>
                            </ModalFooter>
                    </Container>
                </ModalBody>
            </Modal>
        )
    }
}

export default MaskAsCompleted